!function(window) {
function variousUtils ($) {
	
	scrollToTopBtn();


}

// shows scroll to top btn
// on user scroll
// styling inside _elements.scss
function scrollToTopBtn() {

	const $btn = $("#toTopBtn");

	// bind that shows buttons if scrollposition fits
	window.onscroll = function() {scrollFunction()};
	function scrollFunction() {
		if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
			$btn.fadeIn();
		} else {
			$btn.fadeOut();
		}
	}

	// bind click to take to top
	$btn.on("click", function() {
		$("html, body").animate({ scrollTop: 0 }, "slow");
	});
}


module.exports = variousUtils;
window.variousUtils = variousUtils;
window.scrollToTopBtn = scrollToTopBtn;
}(window);